import Home from "./pages/home/Home";
import Project from "./pages/project/Project";
import NoMatch from "./pages/noMatch/NoMatch";
import About from "./pages/about/About";
import Credentials from "./pages/credentials/Credentials";
import CredentialsPopUp from "./components/credentialsPopUp/CredentialsPopUp";
import { useState, useEffect, useRef } from 'react'
import { Routes, Route, useLocation } from "react-router-dom";

import "./styles/mainStyle.scss"
import Admin from "./pages/admin/Admin";
import { logAnalyticsEvent } from "./services/firebase";
import ImpersonateBanner from "./components/impersonateBanner/ImpersonateBanner";

var isMobile = {
  Android: function () { return navigator.userAgent.match(/Android/i); },
  BlackBerry: function () { return navigator.userAgent.match(/BlackBerry/i); },
  iOS: function () { return navigator.userAgent.match(/iPhone|iPad|iPod/i); },
  Opera: function () { return navigator.userAgent.match(/Opera Mini/i); },
  Windows: function () { return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i); },
  any: function () { return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()); }
};

const PageTracker = () => {
  const location = useLocation();
  const lastLoggedPath = useRef(null);

  useEffect(() => {
    const logVisit = async () => {
      const path = location.pathname;
      // Deduplicate: Don't log if path is same as last logged (covers StrictMode and re-renders)
      if (lastLoggedPath.current === path) return;

      if (!["/dashboard", "/admin", "/credentials"].includes(path)) {
        const userId = localStorage.getItem('userId') || 'Anonymous';
        let category = path === '/' ? 'home' : path.replace(/\//g, '_').substring(1);
        if (!category) category = 'home';

        lastLoggedPath.current = path; // Mark as logged BEFORE async call to be safe
        await logAnalyticsEvent('visit', category, userId);
      }
    };

    logVisit();
  }, [location]);

  return null;
};

function App() {
  const [ask, setAsk] = useState(false);
  const [currentItem, setCurrentItem] = useState({});

  // Global listener for private access requests
  useEffect(() => {
    const handleTrigger = (e) => {
      if (e.detail?.item) setCurrentItem(e.detail.item);
      else setCurrentItem({});
      setAsk(true);
    };
    window.addEventListener('trigger-login', handleTrigger);
    return () => window.removeEventListener('trigger-login', handleTrigger);
  }, []);

  return (
    <div className={isMobile.any() ? "app mobile" : "app"}>
      <ImpersonateBanner />

      <PageTracker />
      <div className={ask ? "credentialsContainer ask" : "credentialsContainer"}>
        <div className="credentialBG" onClick={() => { setAsk(false); }} />
        <div className="credentials"><CredentialsPopUp currentItem={currentItem} /></div>
      </div>

      <Routes>
        <Route path="/">
          <Route index element={<NoMatch />} />

          <Route path="home" element={<Home />} />
          <Route path="credentials" element={<Credentials />} />
          <Route path="dashboard" element={<Credentials> <Admin /> </Credentials>} />
          <Route path="about" element={<About />} />

          <Route path="work/:projectSlug" element={<Project />} />
          <Route path="personal" element={<Project />} />
          <Route path="work" element={<Home />} />

          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
